"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CULTURE_CODE = void 0;
var CULTURE_CODE = {
  ENGLISH: 'en-US',
  JAPANESE: 'ja-JP',
  KOREAN: 'ko-KR',
  CHINESE_TRADITIONAL: 'zh-TW',
  SPANISH_ARGENTINA: 'es-AR',
  SPANISH_MEXICO: 'es-MX',
  PORTUGUESE: 'pt-BR'
};
exports.CULTURE_CODE = CULTURE_CODE;